<template>
<main>
  <div>
    <van-nav-bar  @click-left="onClickLeft"
                  title="订单确认"
                  left-arrow/>
                 
                      <van-field
                          v-model.trim="customerName"
                          maxlength="50"
                          show-action
                          required
                            label="商户名称"
                          placeholder="请输入商户名称"
                      >
                        <template #button>
                        <van-icon name="search" @click="searchCustomer()" />
                      </template>
                      
                      </van-field>         
    <van-field
        v-model.trim="customerPhone"
        maxlength="11"
        show-action
         label="电话号码"
         clearable
         required
        placeholder="请输入电话号码"
    ></van-field>
    <div
        style="background-color: #fff;margin-top: 10px"
        :key="order.id"
    >
    <van-card
        style="height: 90px"
        :thumb="order.productPicture"
      >
      <template #title>
        <div style="font-size: 18px;font-weight:bold;margin-left: 30px;margin-top: 10px">
          {{order.spName}}
        </div>
      </template>
      <template #price>
        <div style="font-size: 18px;margin-left: 30px;margin-bottom: 14px">
          收费标准 <span style="color: red">￥{{order.je + "/" + order.dw}}</span>
        </div>
      </template>
    </van-card>
        <div >
          <div style="padding: 15px 15px;float: left">数量</div>
          <van-stepper style=" float: right;text-align: center;margin-right: 100px" v-model="countVal" step="1" input-width="60px" button-size="48px" />
        </div>
        <van-field v-model="remarks" label="备注"/>
    </div>
    <div>
      <div style="padding: 5px 10px;background-color: white;margin-top: 30px">
        <h3>下单须知:</h3>
        <p style="font-size: 16px;color: #969696">
          1. 下单并付款完成后，代表双方正式的环卫服务正式成立，如有疑问，可联系客服了解产品及服务相关信息。
        </p>
        <p style="font-size: 16px;color: #969696">
          2. 订单确认前，请认真确认相关内容，知晓相关产品的相关服务内容，如有疑问，可随时联系官方客服：400-0591-345。
        </p>
      </div>
    </div>
    <van-submit-bar :price="amountCalculation()" button-text="提交订单" @submit="onSubmit" />
  </div>
<div class="selector">
    <van-popup v-model="showPicker" position="bottom" >

        <van-search  v-model="searchText" placeholder="搜索" @input="onSearch"> </van-search>
         <van-picker show-toolbar :columns="showOptions" @confirm="onConfirm"
          @cancel="close" @change="onChange">
    
         </van-picker>
    </van-popup> 
  </div>
</main> 
</template>

<script>
import {Button, Card, Cell, CellGroup, Field, NavBar, Radio, RadioGroup, Search, Stepper, 
SubmitBar, Toast,Picker } from 'vant'
import {Indicator} from "mint-ui";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Search.name]: Search,
    [Card.name]:Card,
    [Stepper.name]:Stepper,
    [Field.name]:Field,
    [SubmitBar.name]:SubmitBar,
    [Picker.name]:Picker
  },
  data() {
    return {
      showPicker:false,
      order: {},
      remarks:'',
      valueCount: '',
      countVal:'',
      orderInfo: [],
      customerPhone:'',
      customerName:'',
       searchText: '', //搜索参数
      currentChoose: null, //当前选中值
      showOptions: [], //展示的下拉列表
      options:''
    };
  },
  mounted() {
    this.init()
  },
   beforeCreate(){   //防止回退

     let linkObj=sessionStorage.getItem("pageLink");
      let  obj = JSON.parse(linkObj)
      if(obj.lastPage!='home'){
        this.$router.push({ path: "/home" });
      }

   },
  methods: {

    onChange(picker, value, index){   //选择改变事件

        let array=value.text.split("/");
         this.customerName=array[0];
         this.customerPhone=array[1];

    },
    onConfirm(value, index){   //确认事件

         let array=value.text.split("/");
         this.customerName=array[0];
         this.customerPhone=array[1];
          this.showPicker=false;
    },
    close(){   //关闭弹窗
          
        this.showPicker=false;

    },
    onSearch(){  //内置的查询事件

     if (this.searchText === '' || this.searchText === null) {
        this.showOptions = this.options;
      } else {
             this.showOptions = this.options.filter((e) => e.text.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1)
      }

    },

    
    searchCustomer(){   //搜索事件打开弹出层

    const url = "/index/customerList";
    this.$axios
      .get(url)
      .then((data) => {
        this.showOptions = data.data;
        this.options=data.data;
         this.showPicker=true;
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });

    },
    onClickLeft(){    //回退事件
      this.$router.push({path: '/home'});
    },
    onSubmit(){   //提交事件

     var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

      if(this.customerPhone!==''&&!reg_tel.test(this.customerPhone)){
        Toast('手机号码格式不正确');
        return ''
      }
      if(this.customerName==''){
        Toast('请输入客户名称');
        return ''
      }

      Indicator.open({
        text: "提交中...",
        spinnerType: "fading-circle"
      });
      let orderId =Date.parse(new Date())+"";
      let orderInfoVo = {
        orderZje: this.amountCalculation()/100,
        orderCode: orderId,
        customerPhone:this.customerPhone,
        customerName:this.customerName,
        orderDetailsVoList: [{
          goodId:this.order.id,
          quantity:this.countVal
        }]
      };
      var url = "/memberBusiness/order/addOrders";  //提交订单
       this.$axios
          .post(url, orderInfoVo)
          .then((res) => {
            console.log(res)
            if (res.code == 200) {
                sessionStorage.setItem("orderZje",this.amountCalculation()/100);
                this.$router.push({
                path: '/collection',
                query: {
                  orderId: orderId,
                },
              });
              Indicator.close();
            }else{
              Toast(res.message)
            }
          })
      Indicator.close();
      this.$router.push({path: ''});
    },
    init() {  //查找商品明细
    var id = this.$route.query.id;
    const url = "/index/" + id + "/productDetails";
    this.$axios
      .get(url)
      .then((data) => {
        this.order = data.data;
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });

    },
    amountCalculation(){
      var that = this
      return (that.countVal * that.order.je)*100;
    },
  }
};

</script>

<style lang="less">
.red {
  color: red;
}

.strong {
  font-weight: bold;
}

.van-cell-group {
  margin-top: 10px;
}

.footer {
  position: fixed;
  bottom: 0px;
}
.van-image__error, .van-image__img, .van-image__loading {
  width: 80%;
  height: 80%;
}
.van-card {
  background-color: #ffffff;
}
.van-stepper {
  margin-top: 10px;
}
.van-stepper__input {
  width: 80px;
  height: 48px;
}
.van-card__thumb img {
  margin-top: 10PX;
  margin-left: 14px;
}
</style>
